<template>
  <div class="avatar-component" :class="avatarUrl ? 'has-avatar' : 'no-avatar'">
    <div v-if="avatarUrl" class="user-avatar-content" :style="`background-image: url('${avatarUrl}')`"></div>
    <div v-else class="user-avatar-content">{{ initials }}</div>
  </div>
</template>

<script lang="ts" setup>

import Account from '../core/Account';

const props = defineProps({
  account: Account
});

const avatarUrl = props.account.getAvatar();

const initials = props.account.getInitials();

</script>

<style lang="scss" scoped>
@import "../core/typography";
.avatar-component {
  position: relative;
  width: var(--size, 36px);
  height: var(--size, 36px);
  flex: 0 0 var(--size, 36px);
  border-radius: 50%;
  @include font-metrics;
  --font-weight: 500;
  --font-size: 12;
  --color: #fff;
  --line-height: normal;
  .user-avatar-content {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #ffffff;
  }
  &.no-avatar .user-avatar-content {
    background: var(--mc-2022-link-color);
  }
  &.has-avatar{
    .user-avatar-content {
      background-size: cover;
      background-position: 50% 50%;
      background-repeat: no-repeat;
      box-shadow: inset 0 0 1px rgba(#232a2f, 0.3);
    }
  }
}
</style>
